// extracted by mini-css-extract-plugin
module.exports = {"firmColor":"#5d3b84","secondaryColor":"silver","successColor":"#4ab675","countCell":"styles_countCell__CW6QG","tooltipName":"styles_tooltipName__ghPbS"};